export default __webpack_public_path__ + "static/media/blogcard3.09a766a2.png";